export default __webpack_public_path__ + "static/media/logo.37bd1b05.png";